import React from 'react'
import {FaRobot} from 'react-icons/fa'

function BotChat(props) {
  return (
    <div class='w-full flex pt-5 pb-8 px-5 font-font2 space-x-5 rounded-lg bg-[#03296b]/5'>
        <div class='p-2 h-fit border-[2px] rounded-full bg-[#fcc502]'>
            <FaRobot color='white' size='1.2rem'/>
        </div>
        <text>{props.content}</text>
    </div>
  )
}

export default BotChat